import Brightness1Icon from "@mui/icons-material/Brightness1";
import { SvgIconTypeMap, styled } from "@mui/material";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from "react";

const EditDotIcon = styled(Brightness1Icon)<Partial<SvgIconTypeMap>>(({ theme }) => ({
  position: "absolute",
  marginLeft: theme.spacing(-1),
  marginTop: theme.spacing(-1),
  width: "20px",
  height: "20px",
  zIndex: 99,
  cursor: "pointer"
}));

export default EditDotIcon;
